import request from './request';

/**
 * 获取所有邮箱配置
 * @returns {Promise}
 */
export function getEmailConfigs() {
  return request({
    url: '/api/email/config/list',
    method: 'get'
  });
}

/**
 * 根据邮箱地址获取配置
 * @param {string} email - 邮箱地址
 * @returns {Promise}
 */
export function getEmailConfigByEmail(email) {
  return request({
    url: '/api/email/config/get',
    method: 'get',
    params: { email }
  });
}

/**
 * 保存邮箱配置
 * @param {Object} data - 邮箱配置数据
 * @param {string} data.email - 邮箱地址
 * @param {string} data.password - SMTP密码
 * @param {number} data.status - 状态 (1: 启用, 0: 禁用)
 * @returns {Promise}
 */
export function saveEmailConfig(data) {
  return request({
    url: '/api/email/config/save',
    method: 'post',
    data
  });
}

/**
 * 更新邮箱配置
 * @param {Object} data - 邮箱配置更新数据
 * @param {string} data.email - 邮箱地址
 * @param {string} data.password - SMTP密码
 * @param {number} data.status - 状态 (1: 启用, 0: 禁用)
 * @returns {Promise}
 */
export function updateEmailConfig(data) {
  return request({
    url: '/api/email/config/update',
    method: 'put',
    data
  });
}

/**
 * 删除邮箱配置
 * @param {string} email - 邮箱地址
 * @returns {Promise}
 */
export function deleteEmailConfig(email) {
  return request({
    url: '/api/email/config/delete',
    method: 'delete',
    params: { email }
  });
}

/**
 * 测试邮件发送
 * @param {Object} data - 测试邮件数据
 * @param {string} data.senderEmail - 发件人邮箱
 * @param {string} data.senderPassword - 发件人密码
 * @param {string} data.recipientEmail - 收件人邮箱
 * @returns {Promise}
 */
export function testEmailSending(data) {
  return request({
    url: '/api/email/config/test',
    method: 'post',
    data
  });
}